import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Admin access now goes through the unified auth page (with mandatory 2FA).
export default function AdminLogin() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/auth", { replace: true });
  }, [navigate]);
  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#050505] flex items-center justify-center">
      <p className="font-mono text-sm tracking-[0.3em] text-zinc-500 uppercase animate-pulse">Redirecting…</p>
    </div>
  );
}
